var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageIconProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 10.9375H16.6665M8.33317 15.1042H11.4582M21.8789 12.5C21.8789 17.6777 17.6816 21.875 12.5039 21.875C10.3826 21.875 3.12966 21.875 3.12966 21.875C3.12966 21.875 4.75381 17.9751 4.10381 16.6675C3.47979 15.4121 3.12891 13.9971 3.12891 12.5C3.12891 7.32233 7.32623 3.125 12.5039 3.125C17.6816 3.125 21.8789 7.32233 21.8789 12.5Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconProduct);
export default __webpack_public_path__ + "static/media/message_icon-product.af957294eaaed3f263ba3d6717ce60f7.svg";
export { ForwardRef as ReactComponent };